<template>
  <!-- LOAD TO INBOX -->
  <div v-show="role == 3 || role == 4">
    <img
      src="@/assets/images/inbox/inbox.svg"
      style="width: 27px; cursor: pointer;"
      class="sm:mr-6 mr-2"
      alt="icon inbox"
      @click="routeInbox"
    />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      privilege: [
        '',
        'Super Administrator',
        'Administrator',
        'Admin Cabang',
        'General User',
        'Dispatcher',
        'Limited User'
      ],
      role: -1,
    }
  },

  created() {
    this.role =
      localStorage.getItem('userInfo') !== null
        ? this.privilege.indexOf(
            JSON.parse(localStorage.getItem('userInfo')).privilege
          )
        : -1
  },

  computed: {
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },

  methods: {
    routeInbox() {
      this.$router.push({ name: 'inbox' })
    }
  }

}
</script>
